import React from "react";
import { LegalLayout, Section, Bullets } from "@/components/legal/LegalLayout";
import { SUPPORT_EMAIL } from "@/constants/legal";

export default function AcceptableUse() {
  return (
    <LegalLayout
      slug="acceptable-use"
      title="Acceptable Use Policy"
      subtitle="This Acceptable Use Policy (“AUP”) sets out what you may and may not do when using HostGuard. It forms part of our Terms of Service."
    >
      <Section title="1. Purpose">
        <p>HostGuard exists to help hosts assess booking risk in a privacy-respecting, non-accusatory way. To keep the service safe, lawful and compliant, all users must follow this policy.</p>
      </Section>

      <Section title="2. Prohibited conduct">
        <p>You must <strong>not</strong>:</p>
        <Bullets items={[
          "Upload or enter unlawful, defamatory, harassing or otherwise objectionable content.",
          "Upload or enter discriminatory information, or use risk scores to discriminate against any person on the basis of a protected attribute (such as race, religion, gender, disability, sexuality or age).",
          "Attempt to identify, profile or surveil any individual, or enter a guest’s full name or other identifying personal details.",
          "Create, contribute to, or attempt to derive a guest blacklist or shared denylist.",
          "Share, publish or disclose personal guest information to other users or third parties.",
          "Reverse engineer, decompile, scrape, or attempt to extract the source code, scoring methodology or AI prompts of the platform.",
          "Abuse, overload, disrupt or attempt to gain unauthorised access to the service, other accounts, or our infrastructure.",
          "Resell, sublicense or provide the service to third parties except as expressly permitted.",
        ]} />
      </Section>

      <Section title="3. Privacy-respecting use">
        <p>HostGuard is intentionally designed around initials and booking characteristics rather than identities. You agree to use it consistently with that design and never to repurpose it as an identity database or blacklist.</p>
      </Section>

      <Section title="4. Compliance with platforms and laws">
        <p>You are responsible for complying with the policies of any booking platform you use (e.g. Airbnb, Stayz, Booking.com), as well as all applicable privacy, anti-discrimination and short-term rental laws in your jurisdiction.</p>
      </Section>

      <Section title="5. Account suspension and termination">
        <p>We reserve the right to investigate suspected breaches and to suspend or terminate accounts that violate this policy, with or without notice, and to remove offending content. Serious or repeated breaches may be reported to relevant authorities where required by law. We may also suspend access where necessary to protect the service or other users.</p>
      </Section>

      <Section title="6. Reporting and contact">
        <p>If you become aware of misuse of HostGuard, please report it to <a href={`mailto:${SUPPORT_EMAIL}`} className="font-medium text-primary hover:underline">{SUPPORT_EMAIL}</a> or via our <a href="/contact" className="font-medium text-primary hover:underline">Contact page</a>.</p>
      </Section>
    </LegalLayout>
  );
}
